import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col, Badge } from "react-bootstrap";
import { GetUserRelativeStudent } from "../../api/DashboardRelativeStudent";
import Cookies from "js-cookie";
import PropTypes from "prop-types";
import * as moment from "moment";
import SeeAllModule from "./admin/SeeAllModule";
import {
  setUserRestriction,
  isFeatureEnabled,
  validateByService,
} from "../global/GlobalTools";

import ProfileImageViewer from "../global/modals/ProfileImageViewer";

const customStyles = {
  containerImg: {
    textAlign: "center",
    position: "relative",
  },
  containerImgTeacher: {
    textAlign: "center",
  },
  styleImg: {
    height: "140px",
    width: "140px",
    border: "solid 1px white",
    aspectRatio: "1/1",
  },
  lazy: {
    height: "25px",
  },
  lazyImgStudent: {
    height: "140px",
    borderRadius: "100px",
    width: "140px",
    left: "75px",
  },
  lazyImgParent: {
    height: "140px",
    borderRadius: "100px",
    width: "140px",
    left: "15px",
  },
  lazyImgTeacher: {
    height: "83px",
    width: "83px",
    borderRadius: "100px",
  },
  lazyTitleTeacher: {
    height: "35px",
  },
  lazyTeacher: {
    height: "20px",
  },
  searchIcon: {
    position: "absolute",
    bottom: "65px",
    background: "#f5f5f5",
    borderRadius: "50%",
    fontSize: "1.2em",
    color: "#999999",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    zIndex: 2,
    height: "25px",
    width: "25px",
    padding: "2px 6px",
  },
};

const lazyLoadingStudent = () => {
  return (
    <div>
      <Row className="table-lazyLoading">
        <Col md={3}>
          <div style={customStyles.lazyImgStudent}></div>
        </Col>
        <Col md={5}>
          <div style={customStyles.lazy}></div>
          <div style={customStyles.lazy}></div>
          <div style={customStyles.lazy}></div>
          <div style={customStyles.lazy}></div>
          <div style={customStyles.lazy}></div>
        </Col>
      </Row>
      <Row className="table-lazyLoading mt-3">
        <Col md={2} className="offset-md-10">
          <div style={customStyles.lazy}></div>
        </Col>
      </Row>
    </div>
  );
};

const lazyLoadingParent = () => {
  return (
    <div>
      <Row className="table-lazyLoading">
        <Col md={3}>
          <div style={customStyles.lazyImgParent}></div>
        </Col>
        <Col md={5}>
          <div style={customStyles.lazy}></div>
          <div style={customStyles.lazy}></div>
          <div style={customStyles.lazy}></div>
        </Col>
      </Row>
      <Row className="table-lazyLoading mt-3">
        <Col md={2} className="offset-md-10">
          <div style={customStyles.lazy}></div>
        </Col>
      </Row>
    </div>
  );
};

const lazyLoadingTeacher = () => {
  return (
    <Row className="table-lazyLoading mt-2">
      <Col xs={3} sm={2}>
        <div style={customStyles.lazyImgTeacher}></div>
      </Col>
      <Col xs={9} sm={10}>
        <div style={customStyles.lazyTitleTeacher}></div>
        <div style={customStyles.lazyTeacher}></div>
        <div style={customStyles.lazyTeacher}></div>
      </Col>
    </Row>
  );
};

const UserInfo = (props) => {
  const [t] = useTranslation([
    "dashboard",
    "dashboardStudent",
    "organizations",
    "crm",
    "class",
    "reports",
    "modalCreateStudent",
    "student",
    "staff",
  ]);
  const prefix = process.env.REACT_APP_PREFIX;
  const userGroup = Cookies.get(`cmGroup${prefix}`);
  const [loadingInfo, setLoadingInfo] = useState(true);
  const [userModule, setUserModule] = useState({});
  const containerRef = useRef(null);
  const iconRef = useRef(null);
  const [showProfileImageViewer, setShowProfileImageViewer] = useState(false);

  /**
   * Gets the parent/student user data
   */
  const userInfoProfile = () => {
    let request = {
      user_id: props.userId,
      // Set timezone
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    GetUserRelativeStudent(request)
      .then((result) => {
        if (result.status) {
          const userInfo = result.data;
          // Get list of students for when logged in as a pa
          if (props.setStudentList && userInfo.students.length) {
            props.setStudentList(userInfo.students);
            const filterDashboard = JSON.parse(
              localStorage.getItem(`cmFiltersDashboard${prefix}`),
            );
            props.setStudentSelected(
              (filterDashboard && filterDashboard.student) ||
                userInfo.students[0],
            );
            setUserModule(userInfo);
          }
          // Obtain user information when logged in with student
          if (userInfo.group_id == "8") {
            setUserModule(userInfo.students[0]);
            props.setIsHigherLevel(userInfo.students[0].program_id != null);
            props.setStudentId(userInfo.students[0].id);
          }
          if (userInfo.group_id == "7") {
            setUserModule(userInfo);
          }
          //Storage of votes in localStorage
          localStorage.setItem(
            `cmUserVotes${prefix}`,
            JSON.stringify(userInfo.votes),
          );
          // Get Restriction
          let hasDebtRestriction = false;
          const students = userInfo.students || [];
          if (students && Array.isArray(students) && students.length !== 0) {
            for (let item of students) {
              hasDebtRestriction =
                item &&
                item.has_debt_restriction &&
                item.has_debt_restriction == 1
                  ? true
                  : false;
              if (hasDebtRestriction) {
                break;
              }
            }
          }
          // Set Cookie
          props.setHasDebtRestriction &&
            props.setHasDebtRestriction(hasDebtRestriction);
          setUserRestriction(hasDebtRestriction);
          if (userInfo.group_id == "7") {
            setUserModule(userInfo);
          }
          //Storage of votes in localStorage
          localStorage.setItem(
            `cmUserVotes${prefix}`,
            JSON.stringify(userInfo.votes),
          );
          setLoadingInfo(false);
        }
      })
      .catch(() => {})
      .finally(() => setLoadingInfo(false));
  };

  const studentProfile = () => {
    if (loadingInfo) return lazyLoadingStudent();
    return (
      <>
        <Row>
          <Col
            md={2}
            sm={3}
            style={customStyles.containerImg}
            ref={containerRef}
          >
            <img
              id="studentProfileImg"
              src={
                userModule.image_url
                  ? userModule.image_url
                  : `${process.env.PUBLIC_URL}/img/student_placeholder.svg`
              }
              className="rounded-circle img-fluid mt-4"
              style={customStyles.styleImg}
              onLoad={handleImgLoad}
            ></img>
            {userModule.image_url &&
              isFeatureEnabled("Importar_Imagenes_Estudiantes") && (
                <i
                  id="zoomIcon"
                  ref={iconRef}
                  className="bi bi-search"
                  style={customStyles.searchIcon}
                  role="button"
                  onClick={() => setShowProfileImageViewer(true)}
                />
              )}
          </Col>
          <Col md={10} sm={9} style={{ minHeight: "215px" }}>
            <Row>
              <b className="fs-3">{userModule.name}</b>
            </Row>
            <Row>
              <p>
                <b>{t("modalCreateStudent:labels.dateBirth")}: </b>
                {moment.unix(userModule.birth_date).utc().format("DD/MM/YYYY")}
              </p>
            </Row>
            <Row>
              <p>
                <b>{t("reports:headerTable.CURP")}: </b>
                {userModule.curp}
              </p>
            </Row>
            <Row>
              <p>
                <b>{t("organizations:modalCreate.email")}: </b>
                {userModule.email}
              </p>
            </Row>
            <Row>
              <Col md={1}>
                <p>
                  <b>{t("class:table.grade")}: </b>
                </p>
              </Col>
              <Col md={1}>
                <b>{t("class:table.group")}: </b>
              </Col>
              <Col md={2}>
                <p>
                  <b>{t("class:modalImport.level")}: </b>
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={1}>
                <p>{userModule.grade}</p>
              </Col>
              <Col md={1}>
                <p>{userModule.group}</p>
              </Col>
              <Col md={2}>
                <p>{userModule.school_level}</p>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mb-2">
            <SeeAllModule
              isCMv1={true}
              customText={t("dashboard:labels.viewProfile")}
              path={`/estudiante/${userModule.id}`}
            ></SeeAllModule>
          </Col>
        </Row>
      </>
    );
  };

  const parentProfile = () => {
    if (loadingInfo) return lazyLoadingParent();

    return (
      <>
        <Row>
          <Col md={3} style={customStyles.containerImg}>
            <img
              src={
                userModule.image_url
                  ? userModule.image_url
                  : `${process.env.PUBLIC_URL}/img/student_placeholder.svg`
              }
              className="rounded-circle img-fluid mt-4"
              style={customStyles.styleImg}
            ></img>
          </Col>
          <Col md={9} style={{ minHeight: "215px" }}>
            <Row>
              <b className="fs-3"> {userModule.name} </b>
            </Row>
            <Row>
              <p>
                <b>{t("organizations:modalCreate.email")}: </b>
                {userModule.email}
              </p>
            </Row>
            <Row>
              <p>
                <b>{t("crm:modalAddProspect.phoneNumer")}: </b>
                {userModule.phone}
              </p>
            </Row>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <SeeAllModule
              isCMv1={true}
              customText={t("dashboard:labels.viewProfile")}
              path={"/user"}
            ></SeeAllModule>
          </Col>
        </Row>
      </>
    );
  };

  const teacherProfile = () => {
    if (loadingInfo) return lazyLoadingTeacher();
    return (
      <Row className="mt-2">
        <Col xs={3} sm={2} style={customStyles.containerImgTeacher}>
          <img
            src={
              userModule.image_url ||
              `${process.env.PUBLIC_URL}/img/student_placeholder.svg"`
            }
            className="rounded-circle"
            width={"83px"}
            height={"83px"}
          ></img>
        </Col>
        <Col xs={9} sm={10}>
          <Row className="align-items-center">
            <Col>
              <b className="text-truncate fs-3">{`${userModule.name}`}</b>
            </Col>
            {isFeatureEnabled("CheckIn_CheckOut_Personal") &&
              validateByService("SCE") && (
                <Col xs="auto">
                  <Badge
                    id="badgeTeacherLocation"
                    pill
                    style={{ fontSize: "12px", padding: "6px 10px" }}
                    bg={
                      userModule.location_status === "inside"
                        ? "success"
                        : "secondary"
                    }
                  >
                    {userModule.location_status === "inside"
                      ? t("staff:location.insideUpper")
                      : t("staff:location.outsideUpper")}
                  </Badge>
                </Col>
              )}
          </Row>
          <Row className="align-items-center">
            <Col>
              <b>{t("labels.level")}:</b> {t(`userRole.teacher`)}
            </Col>
            {isFeatureEnabled("CheckIn_CheckOut_Personal") &&
              validateByService("SCE") &&
              userModule.last_seen && (
                <Col xs="auto">
                  <div id="badgeTeacherLocationTime">
                    {moment(userModule.last_seen).format("DD/MM/YYYY h:mm A")}
                  </div>
                </Col>
              )}
          </Row>
          <Row className="justify-content-end">
            <Col sm={6} md={4} xxl={2}>
              <SeeAllModule
                isCMv1={true}
                customText={t("dashboard:labels.viewProfile")}
                path={"/user"}
              ></SeeAllModule>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  /**
   * Initial Loading
   */
  useEffect(() => {
    userInfoProfile();
  }, []);

  /**
   * Adjust zoom icon position
   */
  const adjustZoomIcon = () => {
    if (containerRef.current && iconRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      iconRef.current.style.right = `${(containerWidth - 135) / 2}px`;
    }
  };

  /**
   * Handle image load event
   */
  const handleImgLoad = () => {
    adjustZoomIcon();
  };

  useEffect(() => {
    window.addEventListener("resize", adjustZoomIcon);
    // Clean up the listener when dismantling
    return () => {
      window.removeEventListener("resize", adjustZoomIcon);
    };
  }, []);

  return (
    <>
      <Row>
        {userGroup == 7 ? (
          teacherProfile()
        ) : (
          <Col md={12} className="mt-3">
            {userGroup == 8 && studentProfile()}
            {userGroup == 6 && parentProfile()}
          </Col>
        )}
      </Row>
      {showProfileImageViewer && (
        <ProfileImageViewer
          show={showProfileImageViewer}
          title={t("student:ModalImportProfilePhotos.profilePicture")}
          txtBtnAccept={t("global:buttons.close")}
          url={userModule.image_url}
          fnAcceptButton={() => setShowProfileImageViewer(false)}
        />
      )}
    </>
  );
};

export default UserInfo;

UserInfo.propTypes = {
  userId: PropTypes.number,
  setStudentSelected: PropTypes.func,
  setStudentList: PropTypes.func,
  setIsHigherLevel: PropTypes.func,
  setHasDebtRestriction: PropTypes.func,
  setStudentId: PropTypes.func,
};
